import {
  IconAlertTriangle,
  IconCheck,
  IconHourglass,
  IconX,
} from "@tabler/icons-react"
import { BadgeVariant } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import {
  CertificateRequestDtoStatusEnumKey,
  certificateRequestDtoStatusEnum,
} from "~/gen/api"

export function useGetCertificateRequestStatus(
  certificateRequestStatus: CertificateRequestDtoStatusEnumKey,
  userType: "brand" | "supplier"
) {
  const { t } = useTranslation(["certificates", "traceability"])

  switch (certificateRequestStatus) {
    case certificateRequestDtoStatusEnum.SUBMITTED:
      return {
        variant: BadgeVariant.WARNING,
        icon: <IconAlertTriangle size={16} />,
        translation:
          userType === "brand"
            ? t("certificates:certificateRequestStatus.SUBMITTED")
            : t("traceability:certificateRequestStatus.SUBMITTED"),
      }
    case certificateRequestDtoStatusEnum.ACCEPTED:
      return {
        variant: BadgeVariant.SUCCESS,
        icon: <IconCheck size={16} />,
        translation:
          userType === "brand"
            ? t("certificates:certificateRequestStatus.ACCEPTED")
            : t("traceability:certificateRequestStatus.ACCEPTED"),
      }
    case certificateRequestDtoStatusEnum.REJECTED:
      return {
        variant: BadgeVariant.ERROR,
        icon: <IconX size={16} />,
        translation:
          userType === "brand"
            ? t("certificates:certificateRequestStatus.REJECTED")
            : t("traceability:certificateRequestStatus.REJECTED"),
      }
    case certificateRequestDtoStatusEnum.OPENED:
      return {
        variant: BadgeVariant.INFO,
        icon: <IconHourglass size={16} />,
        translation:
          userType === "brand"
            ? t("certificates:certificateRequestStatus.OPENED")
            : t("traceability:certificateRequestStatus.OPENED"),
      }
    default:
      return null
  }
}
